import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { EventPlace, TicketUrl } from '../interfaces';
import { getPlace } from '../../redux/actions';
import { Link, useParams } from 'react-router-dom';
import { convertChars, formatDate, formatTime } from '../../helpers/utils';
//import BadMapWidget from '../Event/MapWidget';
import { EventOsmWidget } from '../Event/event-osm-widget';

import {
    ContentTitle,
    ContentBody,
    FeatureImage, Social, SeeAlso, VideoBlock
} from '../common/index';
import { Markup } from 'interweave';
import debounce from 'lodash.debounce';
import { API_URL, HOST_NAME, ROOT_ROUTE } from '../../constants';
import { MainFooter } from '../common/footer'

type PlaceProps = {
    placeId?: number;
    placeReducer?: EventPlace | null;
}

type PlaceEvent = {
    id: number;
    start: number;
    end: number;
    internalurl: string;
    name_eng: string;
    name_nat: string;
    name_rus: string;
    ticketurl: TicketUrl[];
}

const PlaceTitle = (props: { title: string }) => {
    const { title } = props;

    return <div className='event-title'>{title}</div>
}

const makeCoords = (input: string) => {
    let coordinates: { lat: number; lng: number } | null = null;
    if (input?.length) {
        coordinates = {
            lat: parseFloat(input[0].split(',')[0]),
            lng: parseFloat(input[0].split(',')[1]),
        }
    }
    return coordinates;
}

const PlaceEvents = (props: any) => {
    const { place: { events }, className } = props;
    if (!events || !events.length) {
        return null;
    }
    return <div className="event-list place-view">
        <div className="date-group">Sündmused</div>
        {events.map((element: any, idx: number) => {
            const eventUrl = !ROOT_ROUTE || ROOT_ROUTE === '/' ? `${ROOT_ROUTE}/event/${element.internalurl}` : `${ROOT_ROUTE}/event-new/${element.internalurl}`
            const { id, name_nat, start } = element
            const isLast = events.length === idx + 1
            const image = `${API_URL}/event/${element.internalurl}?do=image`
            return (
                <div className='event-list-item' data-event-id={id} key={idx}>
                    {image ?
                        <Link to={eventUrl} >
                            <img
                                className="image"
                                data-element={id}
                                src={image}
                                alt={name_nat} /></Link> : null
                    }
                    <div className={isLast ? 'container' : 'container'}>
                        <Link to={eventUrl}>
                            <div className="event-item-title">
                                <span>{formatDate(element.start) + ' ' + formatTime(element.start)}</span>
                            </div>
                            <div className="event-item-description">
                                {convertChars(name_nat)}
                            </div>
                        </Link>
                    </div>
                </div>
            )
        }
        )}
    </div>
}

const getPlaceImage = (placeImage: string) => {
    if (!placeImage) {
        return false
    }
    if (placeImage.indexOf('http') > -1) {
        return placeImage.replace(HOST_NAME, API_URL);
    } else {
        return `${API_URL}${placeImage}`
    }
}

const RenderMobile = (props: any) => {
    const { place } = props;
    const coordinates = makeCoords(place.coordinates);
    const image = place.image ? getPlaceImage(place.image) : '';
    return (
        <div className="event-view-container pb-main">
            {image ?
                <FeatureImage image={image} title={place.name_nat} desktop={true} /> : null}

            <ContentTitle title={convertChars(place.name_nat)} />
            {place.address ?
                <div className="event-additional-info container">
                    <Markup content={`${place.address}, ${place.city.county.name_nat}, ${place.city.name_nat}`} />
                </div> : null
            }

            <ContentBody description={place.description_nat} />

            {place.homepage_nat ?
                <div className="event-additional-info container">
                    <div className="sub-title">Vaata lisaks</div>
                    <a href={place.homepage_nat}>{place.homepage_nat}</a>
                </div> : null
            }
            <PlaceEvents place={place} />
            {coordinates
                ? <div className='map-container'>
                    <EventOsmWidget coordinates={coordinates} />
                </div>
                : null
            }
            <MainFooter />
            <Social />
        </div>);
}

const RenderDesktop = (props: any) => {
    const { place } = props;
    const coordinates = makeCoords(place.coordinates);
    const image = place.image ? getPlaceImage(place.image) : '';
    return (
        <div className="event-desktop">
            <div className="event-view-container desktop">

                <div className='left-column'>
                    {image ?
                        <FeatureImage image={image} title={place.name_nat} desktop={true} /> : null}
                </div>
                <div className='center-column'>
                    <div className="page-header">
                        <ContentTitle title={convertChars(place.name_nat)} />
                        {place.address_nat ?
                            <div className="event-additional-info container">
                                <Markup content={`${place.address_nat}, ${place.city.county.name_nat}, ${place.city.name_nat}`} />
                            </div> : null
                        }
                    </div>
                    {place.description_nat ?
                        <ContentBody description={place.description_nat} className='border-gray' />
                        : null}
                    {place.homepage_nat ?
                        <div className="event-additional-info container">
                            <div className="sub-title">Vaata lisaks</div>
                            <a href={place.homepage_nat}>{place.homepage_nat}</a>
                        </div> : null
                    }
                    <PlaceEvents place={place} />
                    <Social />
                </div>
                <div className='right-column'>
                    {coordinates
                        ? <div className='map-container'>
                            {/* <BadMapWidget coordinates={coordinates} desktop={true}/> */}
                            <EventOsmWidget coordinates={coordinates} />
                        </div>
                        : null
                    }

                </div>
            </div>
            <MainFooter />
        </div>);
}


const Place = (props: PlaceProps) => {
    const { placeReducer } = props;
    const [currentPlace, setCurrentPlace] = useState<EventPlace | null>(null);
    const [loading, setLoading] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const dispatch = useDispatch();
    const { place } = useParams<{ place: string }>();
    useEffect(() => {
        if (placeReducer) {
            if (currentPlace?.internalurl !== place) {
                if (placeReducer.internalurl === place) {
                    setCurrentPlace(placeReducer)
                    setLoading(false);
                } else {
                    if (!loading) {
                        setLoading(true);
                        dispatch(getPlace(place));
                    } // else just wait for promise resolve
                }
            }
        } else {
            if (!loading) {
                setLoading(true);
                //dispatch(getPlace(place));
            }
        }

        if (!placeReducer) {
            dispatch(getPlace(place));
        }
    }, [placeReducer, place])
    window.onresize = debounce(() => {
        setScreenWidth(window.innerWidth);
    });

    //    return currentPlace ? <RenderDesktop place={currentPlace}/> : null
    return currentPlace ? screenWidth < 991 ? <RenderMobile place={currentPlace} /> : <RenderDesktop place={currentPlace} /> : null;

}

const mapStateToProps = (state: any) => {
    const { placeReducer } = state;
    return { placeReducer }
}

export default connect(mapStateToProps, { getPlace })(Place);
